import { useState } from "react";
import useService from "../../hooks/useServices";
import Gallery from "../Gallery";
import Popup from "../Popup";
import FourAssetsTemplate from "./Templates/FourAssetsTemplate";
import OverFourAssetsTemplate from "./Templates/OverFourAssetsTemplate";

const Detail = ({ id, type }) => {
  const [openedPopUp, setOpenPopUp] = useState(false);
  const { getItemById } = useService({ type });
  const item = getItemById(id);

  return (
    <>
      <div>
        <div
          className="w-full h-screen bg-fixed bg-cover bg-center flex justify-center items-center flex-col"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}${item.highlight})`,
          }}
        >
          <div className="flex-1 flex items-center justify-center">
            <h2 className="font-semibold text-3xl text-white font-oswald">
              {item.name}
            </h2>
          </div>
          <div className="text-white animate-bounce">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-10 h-10"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 8.25l-7.5 7.5-7.5-7.5"
              />
            </svg>
          </div>
        </div>
        <div className="p-12 flex justify-center items-center">
          <p className="w-3/5 text-center whitespace-pre-line">
            {Array.isArray(item.description) && item.description[0]}
          </p>
        </div>
        <div
          className="w-full h-36 bg-fixed bg-cover bg-center flex justify-center items-center"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}${item.highlight})`,
          }}
        />
      </div>
      {item.assets.length <= 4 ? (
        <FourAssetsTemplate
          item={item}
          onOpenPopUp={() => setOpenPopUp(true)}
        />
      ) : (
        <OverFourAssetsTemplate
          item={item}
          onOpenPopUp={() => setOpenPopUp(true)}
        />
      )}

      {/* <div className="flex w-full justify-center p-16">
        <div className="w-96 border-2 border-rose-500 p-1">
          <Gallery assets={item.assets} />
        </div>
      </div> */}

      {openedPopUp && (
        <Popup onClose={() => setOpenPopUp(false)}>
          <Gallery assets={item.assets} />
        </Popup>
      )}
    </>
  );
};

export default Detail;
